import { takeLatest, put, all, call } from 'redux-saga/effects';
import {
  FETCH_DOCUMENT_TYPES,
  fetchDocumentTypesFailed,
  fetchDocumentTypesSuccess,
} from '../ducks/document-types';

import documentAPI from "../integrations/DocumentAPI";
import { DigitalDocumentType } from '../classes/DocumentType';
import {message} from "antd";
import {DocumentTypesMessages} from "../constants/messages";

function* fetchDocumentTypesSaga () {
  try {
    const documentTypes = yield call(documentAPI.getDocumentTypes);
    if (!documentTypes || !documentTypes.dados.length) {
      message.warning(DocumentTypesMessages.fetchError);
      return false;
    }

    yield put(fetchDocumentTypesSuccess(
      documentTypes.dados.map(dado => new DigitalDocumentType(dado.id, dado.description, dado.dpi, dado.width, dado.height))
    ));

  } catch (e) {
    console.error(e);
    yield put(fetchDocumentTypesFailed(e));
  }
}

function* watchFetchDocumentTypes() {
  yield takeLatest(FETCH_DOCUMENT_TYPES, fetchDocumentTypesSaga);
}

export default function* () {
  yield all([
    watchFetchDocumentTypes(),
  ]);
}
